export default {
  title: 'Accedi dal tuo indirizzo',
  description:
    'Questo indirizzo appartiene a un partner di cui il tuo account non fa parte. Per proteggere il tuo account, accedi da dove lo fai di solito: la tua email e la tua password funzionano lì.',
  continue: 'Continua su {{host}}',
  password_changed: 'La tua password è stata modificata.',
};
